<template>
    <div class="bg-white rounded-lg shadow p-3">
        <div class="grid grid-cols-6">
            <div class="col-span-5">

                <div class="w-full h-full flex justify-between items-center">
                    <div class="w-full flex">
                        <p>{{ detail?.name }}</p>
                    </div>
                    <div class="w-full flex">
                        <p>{{ detail?.phone }}</p>
                    </div>
                    <div class="w-full flex">
                        <p>{{ detail?.address }}</p>
                    </div>
                </div>
            </div>
            <div class="col-span-1">
                <div class="flex gap-2 justify-end">
                    <button @click="$emit('edit', detail?.id)" class="bg-orange-500 p-3 rounded"><IconPensil></IconPensil></button>
                    <button @click="$emit('delete', detail?.id)" class="bg-red-500 p-3 rounded"><IconTrash></IconTrash></button>
                </div>
            </div>

        </div>
    </div>
</template>

<script>
import IconPensil from '@icons/IconPensil.vue'
import IconTrash from '@icons/IconTrash.vue'
export default {
    name: "AddressCard",
    components:{
        IconTrash,
        IconPensil
    },
    props: {
        detail: {
            type: Object,
            default: {}
        }
    }
}
</script>